// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"a3609314","38":"472dabee","461":"d74c5b6e","512":"2fb29455","621":"8bd2483e"}[chunkId] + ".chunk.js";
};